import { render, staticRenderFns } from "./ConceptSuggestions.vue?vue&type=template&id=5fa35894&scoped=true"
import script from "./ConceptSuggestions.vue?vue&type=script&lang=js"
export * from "./ConceptSuggestions.vue?vue&type=script&lang=js"
import style0 from "./ConceptSuggestions.vue?vue&type=style&index=0&id=5fa35894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa35894",
  null
  
)

export default component.exports